
import { MainPublicationEventModel } from '../models/MainPublicationEventModel.js';
import { MainPublicationEventView } from '../views/MainPublicationEventView.js';

export class MainPublicationEventController {
    constructor() {

        this.model = new MainPublicationEventModel();
        this.view = new MainPublicationEventView();

        this.model.subscribe(state => this.view.render(state));
    }
}